import { Gaps } from './gaps';
import { Colors } from './colors';

const Variables = {
    defaultBorderRadius: "24px",
    footerHeight: '120px',
    drawerWidth: 240
}

export { Gaps, Colors, Variables };